const constants = {
    k: '8b1b1dc74a7f4d192f01e2fa234518167f3b31b9f9e4e71c83fca59004db7da4'
}

export default constants;